import React, { useState, useEffect, useRef } from 'react';
import {
  Container,
  Row,
  Col,
} from 'reactstrap';
import { connect } from 'react-redux';
import { IAuthReduxProps, IBienCardInfo, ITarget } from '../../types/interfaces';
import { useAlert } from "react-alert";
import ReactTooltip from 'react-tooltip';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowLeft, faBuilding, faHashtag, faHouseDamage, faLayerGroup, faMoneyBill, faMoneyBillAlt, faRulerCombined, faThLarge, faCompass, faMap, faQuestionCircle, faSquare, faCheckSquare, faMapMarkerAlt, faSignature, faFolder, faPercent, faCheck, faPen } from '@fortawesome/free-solid-svg-icons'
import { getBienStatut } from '../../services/misc';
import { PRIVILEGE } from '../../types/privileges';
import { constants } from '../../types/constants';

const BienCardInfo = ({ 
  selectedBien,
  auth
 }: IBienCardInfo) => {
  const [imageUrl, setImageUrl] = useState('');
  const [editVenteData, setEditVenteData] = useState<any>('');
  const [editVenteModal, setEditVenteModal] = useState(false);

  useEffect(() => {
    switch(selectedBien.TYPE_2?.toLowerCase()){
      case constants.LOT: setImageUrl("url('/images/soil.png')"); break;
      case constants.VILLA: setImageUrl("url('/images/villa.png')"); break;
      case constants.APPARTEMENT: setImageUrl("url('/images/apartment.png')"); break;
      case constants.MAGASIN: setImageUrl("url('/images/shop.png')"); break;
      case constants.EQUIPEMENT: setImageUrl("url('/images/equipment.png')"); break;
      default: setImageUrl(""); break;
    }
  }, [selectedBien.TYPE_2])
  useEffect(() => {console.log("selectedBien", selectedBien)}, [selectedBien])
  
  return (
    <div className="fadeAnimation">
      {!selectedBien?.contrat ? <Container className="CardInfo">
        <Row className="padding-0">
          <Col xs="12" md="3" className="cardImageContainer">
            <div title={selectedBien.TYPE_2 || ""} className="cardImage" style={{backgroundImage: imageUrl}}></div>
            <div className="cardImageTitle">{selectedBien.TYPE || '-'}</div>
          </Col>
          <Col xs="12" md="9" style={{border: "none"}}>
            <Row>
              <Col xs="12">
                <FontAwesomeIcon icon={faCheck} />&nbsp;<strong>Statut : </strong>{selectedBien.STATUT === "SIGNE NOTAIRE" ? "Signé notaire" : selectedBien.STATUT === "UNIQUE" ? "Vente normale" : selectedBien.STATUT === "ASSOCIATION CLOTUREE" ? "Association clôturée" : selectedBien.STATUT === "ASSOCIATION OUVERTE" ? "Association ouverte" : selectedBien.STATUT === "BLOQUE" ? "Bloqué" : selectedBien.STATUT === "DISPONIBLE" ? "Disponible" : (selectedBien.STATUT || "-")}
              </Col>
            </Row>
            <Row>
              <Col xs="12" sm="6">
                {/* <FontAwesomeIcon icon={faHouseDamage} />&nbsp;<strong>Type : </strong>{selectedBien.TYPE || '-'} */}
                <FontAwesomeIcon icon={faMapMarkerAlt} />&nbsp;<strong>Projet : </strong>{selectedBien.PROJET || '-'}
              </Col>
              <Col xs="12" sm="6">
                <FontAwesomeIcon icon={faHashtag} />&nbsp;<strong>N° : </strong>{selectedBien.N}
              </Col>
            </Row>
            {!selectedBien?.STATUT?.toUpperCase().includes("ASSOCIATION") && <Row>
              <Col xs="12" sm="6">
                <FontAwesomeIcon icon={faThLarge} />&nbsp;<strong>Tranche : </strong>{selectedBien.TRANCHE || "-"}
              </Col>
              <Col xs="12" sm="6">
                <FontAwesomeIcon icon={faBuilding} />&nbsp;<strong>Immeuble : </strong>{!selectedBien.IMMEUBLE && selectedBien.IMMEUBLE !== "0" ? "-" : selectedBien.IMMEUBLE}
              </Col>
            </Row>}
            {!selectedBien?.STATUT?.toUpperCase().includes("ASSOCIATION") && <Row>
              <Col xs="12" sm="6">
                <FontAwesomeIcon icon={faLayerGroup} />&nbsp;<strong>Étage N° : </strong>{!selectedBien.ETAGE && selectedBien.ETAGE !== "0" ? "-" : selectedBien.ETAGE}
              </Col>
              <Col xs="12" sm="6">
                <FontAwesomeIcon icon={faRulerCombined} />&nbsp;<strong>Superficie : </strong>{selectedBien.TYPE_2?.toLowerCase() === "appartement" ? "-" : (selectedBien.SUPERFICIE + "m²")}
              </Col>
            </Row>}
            {selectedBien?.STATUT?.toUpperCase().includes("ASSOCIATION") && <Row>
              <Col xs="12" sm="6">
                <FontAwesomeIcon icon={faThLarge} />&nbsp;<strong>Tranche : </strong>{selectedBien.TRANCHE || "-"}
              </Col>
              <Col xs="12" sm="6">
                <FontAwesomeIcon icon={faRulerCombined} />&nbsp;<strong>Superficie : </strong>{selectedBien.TYPE_2?.toLowerCase() === "appartement" ? "-" : (selectedBien.SUPERFICIE + "m²")}
              </Col>
            </Row>}
            {(selectedBien.ORIENTATION || selectedBien.POSITION) && <Row>
              <Col xs="12" sm="6">
                <FontAwesomeIcon icon={faCompass} />&nbsp;<strong>Orientation : </strong>{selectedBien.ORIENTATION || "-"}
              </Col>
              <Col xs="12" sm="6">
                <FontAwesomeIcon icon={faMap} />&nbsp;<strong>Position : </strong>{selectedBien.POSITION || "-"}
              </Col>
            </Row>}
            <Row>
              <Col xs="12" sm="6">
                <FontAwesomeIcon icon={faMoneyBillAlt} />&nbsp;<strong>Prix du M² : </strong>{(selectedBien.PRIX_M !== null && selectedBien.PRIX_M !== undefined && selectedBien.PRIX_M != "") ? (selectedBien.PRIX_M.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " Dh") : "-"}
              </Col>
              <Col xs="12" sm="6">
                <FontAwesomeIcon icon={faMoneyBill} />&nbsp;<strong>Prix du bien : </strong>{(selectedBien.PRIX_VENTE !== null && selectedBien.PRIX_VENTE !== undefined && selectedBien.PRIX_VENTE != "") ? (selectedBien.PRIX_VENTE.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " Dh") : "-"}
              </Col>
            </Row>
          </Col>
        </Row>
      </Container> : <Container className="CardInfo fadeAnimation">
        <Row className="padding-0">
          <Col xs="12" md="3" className="cardImageContainer">
            <div title={selectedBien.TYPE_2 || ""} className="cardImage" style={{backgroundImage: imageUrl}}></div>
            <div className="cardImageTitle">{selectedBien.contrat.TYPE || '-'}</div>
          </Col>
          <Col xs="12" md="9" style={{border: "none"}}>
            <div style={{display: "flex", justifyContent: "flex-end", fontStyle: "italic", fontSize: "x-small"}}>
              {auth?.user?.privileges?.includes(PRIVILEGE.EDIT_PRIX_MIN) ? <div className="consultationEditBtn" onClick={() => {setEditVenteData(selectedBien); setEditVenteModal(true)}}>
                <FontAwesomeIcon icon={faPen} />&nbsp;<div style={{textDecoration: "underline"}}>Modifier</div>
              </div> : null}
            </div>
            <Row>
              <Col xs="12">
                <FontAwesomeIcon icon={faCheck} />&nbsp;<strong>Statut : </strong>{getBienStatut(selectedBien.STATUT) || "-"}
              </Col>
            </Row>
            <Row>
              <Col xs="12" sm="6">
                <FontAwesomeIcon icon={faSignature} />&nbsp;<strong>ID Bien : </strong>{selectedBien.contrat.ID_BIEN}
              </Col>
              <Col xs="12" sm="6">
                <FontAwesomeIcon icon={faFolder} />&nbsp;<strong>Dossier N° : </strong>{selectedBien.contrat.NUM_DOSS}
              </Col>
            </Row>
            <Row>
              <Col xs="12" sm="6">
                <FontAwesomeIcon icon={faMapMarkerAlt} />&nbsp;<strong>Projet : </strong>{selectedBien.contrat.PROJET || '-'}
                {/* <FontAwesomeIcon icon={faHouseDamage} />&nbsp;<strong>Type : </strong>{selectedBien.contrat.TYPE || '-'} */}
              </Col>
              <Col xs="12" sm="6">
                <FontAwesomeIcon icon={faHashtag} />&nbsp;<strong>N° : </strong>{selectedBien.contrat.N}
              </Col>
            </Row>
            {selectedBien?.contrat.TYPE_VENTE !== "ASSOCIATION" && <Row>
              <Col xs="12" sm="6">
                <FontAwesomeIcon icon={faThLarge} />&nbsp;<strong>Tranche : </strong>{selectedBien.contrat.TRANCHE || "-"}
              </Col>
              <Col xs="12" sm="6">
                <FontAwesomeIcon icon={faBuilding} />&nbsp;<strong>Immeuble : </strong>{!selectedBien.contrat.IMMEUBLE && selectedBien.contrat.IMMEUBLE !== "0" ? "-" : selectedBien.contrat.IMMEUBLE}
              </Col>
            </Row>}
            {selectedBien?.contrat.TYPE_VENTE !== "ASSOCIATION" && <Row>
              <Col xs="12" sm="6">
                <FontAwesomeIcon icon={faLayerGroup} />&nbsp;<strong>Étage N° : </strong>{!selectedBien.contrat.ETAGE && selectedBien.contrat.ETAGE !== "0" ? "-" : selectedBien.contrat.ETAGE}
              </Col>
              <Col xs="12" sm="6">
                <FontAwesomeIcon icon={faRulerCombined} />&nbsp;<strong>Superficie : </strong>{selectedBien.contrat.TYPE_2?.toLowerCase() === "appartement" ? "-" : (selectedBien.contrat.SUPERFICIE + "m²")}
              </Col>
            </Row>}
            {selectedBien?.contrat.TYPE_VENTE === "ASSOCIATION" && <Row>
              <Col xs="12" sm="6">
                <FontAwesomeIcon icon={faThLarge} />&nbsp;<strong>Tranche : </strong>{selectedBien.contrat.TRANCHE || "-"}
              </Col>
              <Col xs="12" sm="6">
                <FontAwesomeIcon icon={faRulerCombined} />&nbsp;<strong>Superficie : </strong>{selectedBien.contrat.TYPE_2?.toLowerCase() === "appartement" ? "-" : (selectedBien.contrat.SUPERFICIE + "m²")}
              </Col>
            </Row>}
            {(selectedBien.contrat.ORIENTATION || selectedBien.contrat.POSITION) && <Row>
              <Col xs="12" sm="6">
                <FontAwesomeIcon icon={faCompass} />&nbsp;<strong>Orientation : </strong>{selectedBien.contrat.ORIENTATION || "-"}
              </Col>
              <Col xs="12" sm="6">
                <FontAwesomeIcon icon={faMap} />&nbsp;<strong>Position : </strong>{selectedBien.contrat.POSITION || "-"}
              </Col>
            </Row>}
            {selectedBien.contrat.REMISE || selectedBien.contrat.PRIX_M_CLIENT ? <Row>
              <Col xs="12" sm="6">
                <FontAwesomeIcon icon={faPercent} />&nbsp;<strong>Remise : </strong>{(selectedBien.contrat.REMISE !== null && selectedBien.contrat.REMISE !== undefined) ? (<div style={{display: "inline-block", ...(selectedBien.contrat.REMISE > 0 ? selectedBien.contrat.REMISE_VALIDEE === -1 ? {color: "orangered"} : selectedBien.contrat.REMISE_VALIDEE === 0 ? {color: "red"} : {} : {})}}>
                  {selectedBien.contrat.REMISE.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}&nbsp;Dh{selectedBien.contrat.REMISE > 0 ? " (du total)" : ""}&nbsp;
                  {selectedBien.contrat.REMISE > 0 && (selectedBien.contrat.REMISE_VALIDEE === -1 || selectedBien.contrat.REMISE_VALIDEE === 0) ? <div style={{display: "inline-block"}}>
                    <FontAwesomeIcon icon={faQuestionCircle} style={{cursor: "pointer"}} data-tip data-for="remise_tooltip" />
                    <ReactTooltip effect="solid" id="remise_tooltip" type={"dark"}>
                      {selectedBien.contrat.REMISE_VALIDEE === -1 ? "Demande de remise pas encore validée par l'administration" : selectedBien.contrat.REMISE_VALIDEE === 0 ? "Demande de remise refusée par l'administration" : ""}
                    </ReactTooltip>
                  </div> : null}
                </div>) : "-"}
              </Col>
              <Col xs="12" sm="6">
                <FontAwesomeIcon icon={faMoneyBill} />&nbsp;<strong>Prix comm. Client : </strong>{(selectedBien.contrat.PRIX_M_CLIENT !== null && selectedBien.contrat.PRIX_M_CLIENT !== undefined) ? (selectedBien.contrat.PRIX_M_CLIENT.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " Dh (du total)") : "-"}
              </Col>
            </Row> : null}
            <Row>
              <Col xs="12" sm="6">
                <FontAwesomeIcon icon={faMoneyBillAlt} />&nbsp;<strong>Prix Net du M² : </strong>{(selectedBien.contrat.PRIX_M !== null && selectedBien.contrat.PRIX_M !== undefined) ? (selectedBien.contrat.PRIX_M.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " Dh") : "-"}
              </Col>
              <Col xs="12" sm="6">
                <FontAwesomeIcon icon={faMoneyBill} />&nbsp;<strong>Prix Net : </strong>{(selectedBien.contrat.PRIX_NET !== null && selectedBien.contrat.PRIX_NET !== undefined) ? (selectedBien.contrat.PRIX_NET.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " Dh") : "-"}
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>}
    </div>
  );
};

const mapStateToProps = (state: IAuthReduxProps) => ({
  auth: state.auth,
  error: state.error,
});

export default connect(mapStateToProps, {  })(BienCardInfo);
